import { render } from "./MailSendStatusDotComponent.vue?vue&type=template&id=b4ff7124&scoped=true"
import script from "./MailSendStatusDotComponent.vue?vue&type=script&lang=js"
export * from "./MailSendStatusDotComponent.vue?vue&type=script&lang=js"

import "./MailSendStatusDotComponent.vue?vue&type=style&index=0&id=b4ff7124&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4ff7124"]])

export default __exports__